import React from 'react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import { Icon } from '@iconify/react';
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Button, Typography, InputAdornment } from '@mui/material';

import AccountPopover from './account-popover';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
import { MHidden } from '../../components';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { toast } from 'react-toastify';
import { When } from 'react-if';
import { useEffectiveSettings, SETTING } from '../../hooks/use-effective-settings';

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 40;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`
  }
}));

const ToolbarStyle = styled(Box)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  marginTop: 8,
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(0, 5)
  },
}));

interface Props {
  onOpenSidebar(): void,
};

const DashboardNavbar: React.FC<Props> = ({ onOpenSidebar }) => {
  const { authUser } = useSelector((state: RootState) => state.auth);
  const { selectedSubscription } = useSelector((state: RootState) => state.customer);
  const { isCollapse, onToggleCollapse } = useCollapseDrawer();
  const { getSetting } = useEffectiveSettings();
  // The invite code exists to join mobile app users; IRA-standalone orgs have
  // zero licenses, so showing it would only invite confusion.
  const isIraStandalone = getSetting<string>(SETTING.organizationType, 'full') === 'iraStandalone';

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` }
        })
      }}
    >
      <ToolbarStyle>
        <Stack display="flex" direction="row" justifyContent="space-between">
          <MHidden width="lgDown">
            <IconButton onClick={onToggleCollapse} sx={{ mr: 1, color: 'text.primary' }}>
              <Icon icon={menu2Fill} />
            </IconButton>
          </MHidden>
          <MHidden width="lgUp">
            <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
              <Icon icon={menu2Fill} />
            </IconButton>
          </MHidden>
        
            <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
              <When condition={!authUser.pomMaster && !isIraStandalone}>
                <Typography fontSize={14} color="text.primary" fontWeight={500} sx={{ mr: 2 }} >
                  Invite code:
                  <strong 
                    style={{ cursor: 'pointer' }}
                    onClick={async () => {
                      await navigator.clipboard.writeText(selectedSubscription?.inviteCode);
                      toast(
                        'Invite code successfully copied!',
                        {
                          autoClose: 1500,
                          type: 'success',
                        },
                      );
                    }}
                  >
                    {' '}{selectedSubscription?.inviteCode}
                  </strong>
                </Typography>
              </When>
              <AccountPopover />
            </Stack>
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}

export default DashboardNavbar;